import * as moment from 'moment';
import * as _ from 'lodash';
import { Component } from 'react';
import { Utility } from '@nkr/services/utility';
import { connect, Dispatch } from 'react-redux';
import {
    DonorShieldDirectActionCreators, AppActionCreators, IApplicationState, IAppState, IDashDonorExistingResponse, IDonorShieldDirectResponse,
    IDonorShieldLookupDataResponse, IDonorShieldDirectDuplicateCountResponse, IDonorShieldAliasCheckResponse,
    IDonorShieldDirectSaveRequest, IAddressValidationResponse
} from '@nkr/store/index';
import { IDonorShieldDirectAddEdit, IDashDonorShield, IListItem, DonorShieldAliasType, IUsPsAddressResponse } from '@nkr/models/index';
import { Country, DonorShieldDirectCategory, OrganType } from '@nkr/enums/index';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { AddEditWrapper } from './styles';
import { toast } from 'react-toastify';
import { IValidation } from './validation';
import SurgeryDetails from './surgery-details';
import DonorDetails from './donor-details';
import RecipientDetails from './recipient-details';
import DonorShieldAliasCheckModal from '../donor-shield-alias-check';
import OrderSerologyConfirmation from './order-serology-confirmation';
import AddressValidation, { IAddress } from '@nkr/components/address-validation';
import { AddressValidationResult } from '@nkr/enums/address-validation-result';

const tabMap = [
    { id: DonorShieldDirectCategory.PendTrans, section: 'PENDING-TRANSPLANT' },
    { id: DonorShieldDirectCategory.Transplanted, section: 'TRANSPLANTED' },
    { id: DonorShieldDirectCategory.AddDonor, section: 'ADD-DONOR' },
    { id: DonorShieldDirectCategory.EditDonor, section: 'EDIT-DONOR' },
    { id: DonorShieldDirectCategory.UploadLostWage, section: 'UPLOAD-LOST-WAGE' }
];

interface IProps {
    donorShieldId: number,
    centerId: number,
    isAdmin: boolean,
    isAdminLogin: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getDonorShieldLookupData: (centerId: number, isAdmin: boolean) => Promise<IDonorShieldLookupDataResponse>,
    getDonorShieldDirectRecord: (donorShieldId: number) => Promise<IDonorShieldDirectResponse>,
    addDonorShieldDirectRecord: (request: IDonorShieldDirectSaveRequest) => Promise<IDonorShieldDirectResponse>,
    updateDonorShieldDirectRecord: (id: number, request: IDonorShieldDirectSaveRequest) => Promise<IDonorShieldDirectResponse>,
    getExistingRegistrations: (centerId: number, donorEmail: string) => Promise<IDashDonorExistingResponse>,
    getDuplicateCounts: (donorShieldId: number, donorAlias: string, recipientAlias: string) => Promise<IDonorShieldDirectDuplicateCountResponse>,
    checkDonorShieldDirectAlias: (email: string, alias: string, type: DonorShieldAliasType, id: number, organType: OrganType) => Promise<IDonorShieldAliasCheckResponse>,
    validateAddress: (address: string, address2: string, city: string, state: string, postalCode: string) => Promise<IAddressValidationResponse>
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    id: number,
    data: IDonorShieldDirectAddEdit,
    category: DonorShieldDirectCategory,
    initSurgeryDate: string,
    validationSave: IValidation,
    dirty: boolean,
    stateList: IListItem[],
    insuranceList: IListItem[],
    organTypeList: IListItem[],
    isExpertSystemCenter: boolean,
    aliasCheck: {
        type: DonorShieldAliasType,
        email: string,
        alias: string
    },
    showAliasCheckModal: boolean,
    showExistingRegistrationNotice: boolean,
    lastLookedUpEmail: string,
    originalDonorAlias: string,
    originalDonorEmail: string,
    originalData: {
        address: string,
        address2: string,
        city: string,
        state: number,
        postalCode: string
    },
    addressValidation: {
        show: boolean,
        response: IUsPsAddressResponse,
        submittedAddress: IAddress,
    },
    sendInvite: boolean,
    orderSerologyConfirmation: {
        show: boolean,
        inviteToDS: boolean,
        newId: number
    }
}

class DonorShieldDirectAddEdit extends Component<TProps, IState> {
    readonly state: IState = {
        id: 0,
        initSurgeryDate: '',
        data: {
            id: 0,
            watrId: 0,
            centerId: this.props.centerId,
            isBilled: false,
            surgeryDate: '',
            donorId: 0,
            donorUnosId: '',
            donorAlias: '',
            donorEmail: '',
            donorAboType: 0,
            donorGender: 0,
            donorName: '',
            donorAddressLine1: '',
            donorAddressLine2: '',
            donorCity: '',
            donorState: 0,
            donorPostalCode: '',
            donorPhoneNumber: '',
            donorBirthdate: '',
            organType: -1,
            recipientAlias: '',
            recipientEmail: '',
            recipientFirstName: '',
            recipientLastName: '',
            recipientAboType: 0,
            recipientUnosCpra: '0',
            recipientGender: 0,
            recipientBirthdate: '',
            recipientPrimaryInsurance: 0,
            recipientSecondaryInsurance: 0,
            country: Country.UnitedStates,
            countryOfCitizenship: Country.UnitedStates,
            hasStreamlinedSerologyOrder: false
        },
        category: DonorShieldDirectCategory.AddDonor,
        validationSave: {
            surgeryDate: true,
            donorUnosId: true,
            donorAlias: true,
            donorEmail: true,
            donorAboType: true,
            donorGender: true,
            donorName: true,
            donorAddressLine1: true,
            donorCity: true,
            donorState: true,
            donorPostalCode: true,
            donorPhoneNumber: true,
            donorBirthdate: true,
            organType: true,
            recipientAlias: true,
            recipientFirstName: true,
            recipientLastName: true,
            recipientAboType: true,
            recipientGender: true,
            recipientBirthdate: true,
            recipientPrimaryInsurance: true,
            recipientUnosCpra: true,
            recipientAliasDuplicate: true,
            surgeryBilled: true,
            surgeryInsurance: true
        },
        dirty: false,
        stateList: [],
        insuranceList: [],
        organTypeList: [],
        isExpertSystemCenter: false,
        aliasCheck: {
            type: DonorShieldAliasType.DonorShieldDirect,
            email: '',
            alias: ''
        },
        showAliasCheckModal: false,
        showExistingRegistrationNotice: false,
        lastLookedUpEmail: '',
        originalDonorAlias: '',
        originalDonorEmail: '',
        originalData: {
            address: '',
            address2: '',
            city: '',
            state: 0,
            postalCode: ''
        },
        addressValidation: {
            show: false,
            response: null,
            submittedAddress: null,
        },
        sendInvite: false,
        orderSerologyConfirmation: {
            show: false,
            inviteToDS: false,
            newId: 0
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Retrieving Donor Shield Donation, one moment please...').then(async () => {
            let lookupDataResponse = await this.props.getDonorShieldLookupData(this.props.centerId, this.props.isAdmin);

            if (this.props.donorShieldId > 0) {
                let donorShieldResponse = await this.props.getDonorShieldDirectRecord(this.props.donorShieldId);

                if (donorShieldResponse.data.success && lookupDataResponse.data.success) {
                    let {
                        id,
                        watrId,
                        surgeryDate,
                        donorId,
                        isBilled,
                        donorUnosId,
                        donorAlias,
                        donorEmail,
                        donorAboType,
                        donorGender,
                        donorName,
                        donorAddressLine1,
                        donorAddressLine2,
                        donorCity,
                        donorState,
                        donorPostalCode,
                        donorPhoneNumber,
                        donorBirthdate,
                        organType,
                        recipientAlias,
                        recipientEmail,
                        recipientFirstName,
                        recipientLastName,
                        recipientAboType,
                        recipientUnosCpra,
                        recipientGender,
                        recipientBirthdate,
                        recipientPrimaryInsurance,
                        recipientSecondaryInsurance,
                        country,
                        countryOfCitizenship,
                        hasStreamlinedSerologyOrder
                    } = donorShieldResponse.data.results;

                    let { insuranceList, stateList, organTypeList, isExpertSystemCenter } = lookupDataResponse.data.results;

                    if (isExpertSystemCenter) {
                        organType = OrganType.Liver;
                    }

                    this.setState({
                        id: this.props.donorShieldId,
                        data: {
                            id,
                            watrId,
                            centerId: this.props.centerId,
                            isBilled,
                            surgeryDate,
                            donorId,
                            donorUnosId,
                            donorAlias,
                            donorEmail,
                            donorAboType,
                            donorGender,
                            donorName,
                            donorAddressLine1,
                            donorAddressLine2,
                            donorCity,
                            donorState,
                            donorPostalCode,
                            donorPhoneNumber: this.formatPhoneNumber(donorPhoneNumber),
                            donorBirthdate,
                            organType,
                            recipientAlias,
                            recipientEmail,
                            recipientFirstName,
                            recipientLastName,
                            recipientAboType,
                            recipientUnosCpra,
                            recipientGender,
                            recipientBirthdate,
                            recipientPrimaryInsurance,
                            recipientSecondaryInsurance,
                            country,
                            countryOfCitizenship,
                            hasStreamlinedSerologyOrder
                        },
                        initSurgeryDate: surgeryDate,
                        insuranceList,
                        stateList,
                        organTypeList,
                        isExpertSystemCenter,
                        category: DonorShieldDirectCategory.EditDonor,
                        originalDonorAlias: donorAlias,
                        originalDonorEmail: donorEmail,
                        originalData: {
                            address: donorAddressLine1,
                            address2: donorAddressLine2,
                            city: donorCity,
                            state: 0,
                            postalCode: donorPostalCode
                        },
                    });
                }
            } else {
                if (lookupDataResponse.data.success) {
                    let { insuranceList, stateList, organTypeList, isExpertSystemCenter } = lookupDataResponse.data.results;

                    let data = { ...this.state.data };

                    if (isExpertSystemCenter || this.props.app.site.organType == OrganType.Liver) {
                        data.organType = OrganType.Liver;
                    }

                    this.setState({
                        data,
                        insuranceList,
                        stateList,
                        organTypeList,
                        isExpertSystemCenter,
                        category: DonorShieldDirectCategory.AddDonor
                    });
                }
            }
            this.props.hideLoading();
        });
    }

    validateSave = async () => {
        let surgeryChanged = false;
        let checkSurgeryInsurance = false;
        let checkSurgeryBilled = false;

        let {
            id,
            surgeryDate,
            donorUnosId,
            donorAlias,
            donorEmail,
            donorAboType,
            donorGender,
            donorName,
            donorAddressLine1,
            donorCity,
            donorState,
            donorPostalCode,
            donorPhoneNumber,
            donorBirthdate,
            organType,
            isBilled,
            recipientAlias,
            recipientFirstName,
            recipientLastName,
            recipientAboType,
            recipientGender,
            recipientBirthdate,
            recipientPrimaryInsurance,
            recipientUnosCpra
        } = this.state.data;

        if (this.state.category === DonorShieldDirectCategory.AddDonor) {
            checkSurgeryInsurance = moment(this.state.data.surgeryDate, 'MM/DD/YYYY').isBefore(moment().startOf('month'));
        } else {
            let initSurgeryDate = _.cloneDeep(this.state.initSurgeryDate);
            surgeryChanged = initSurgeryDate !== this.state.data.surgeryDate;
            checkSurgeryInsurance = moment(this.state.data.surgeryDate, 'MM/DD/YYYY').isBefore(moment().startOf('month')) && surgeryChanged;
            checkSurgeryBilled = surgeryChanged && isBilled;
        }

        let recipientAliasCount = 0;

        if (recipientAlias != '') {
            let duplicateReponse = await this.props.getDuplicateCounts(id, donorAlias, recipientAlias);
            recipientAliasCount = duplicateReponse.data.results.recipientAliasCount;
        }

        let validSurgeryDate = true;

        if (moment(surgeryDate, 'MM/DD/YYYY', true).isValid() == false) {
            validSurgeryDate = false;
        } else {
            validSurgeryDate = moment(this.state.data.surgeryDate) >= moment().startOf('month');
        }

        let strippedPhone = this.stripPhoneNumber(donorPhoneNumber);
        let validPhoneNumber = strippedPhone.length === 10;

        let validation: IValidation = {
            surgeryDate: validSurgeryDate,
            donorUnosId: donorUnosId !== '',
            donorAlias: donorAlias !== '',
            donorEmail: Utility.isValidEmail(donorEmail),
            donorAboType: donorAboType !== 0,
            donorGender: donorGender !== 0,
            donorName: donorName !== '',
            donorAddressLine1: donorAddressLine1 !== '',
            donorCity: donorCity !== '',
            donorState: donorState !== 0,
            donorPostalCode: donorPostalCode !== '',
            donorPhoneNumber: validPhoneNumber,
            donorBirthdate: moment(donorBirthdate, 'MM/DD/YYYY').isValid(),
            organType: organType !== -1,
            recipientAlias: recipientAlias !== '',
            recipientFirstName: !!recipientFirstName?.trim(),
            recipientLastName: !!recipientLastName?.trim(),
            recipientAboType: recipientAboType !== 0,
            recipientGender: recipientGender !== 0,
            recipientBirthdate: moment(recipientBirthdate, 'MM/DD/YYYY').isValid(),
            recipientPrimaryInsurance: recipientPrimaryInsurance !== 0,
            recipientUnosCpra: Utility.isNumber(recipientUnosCpra),
            recipientAliasDuplicate: recipientAliasCount === 0,
            surgeryBilled: !checkSurgeryBilled,
            surgeryInsurance: !checkSurgeryInsurance
        };

        return validation;
    }

    isValid = () => {
        let { validationSave } = this.state;

        return (
            validationSave.surgeryDate &&
            validationSave.donorUnosId &&
            validationSave.donorAlias &&
            validationSave.donorEmail &&
            validationSave.donorAboType &&
            validationSave.donorGender &&
            validationSave.donorName &&
            validationSave.donorAddressLine1 &&
            validationSave.donorCity &&
            validationSave.donorState &&
            validationSave.donorPostalCode &&
            validationSave.donorPhoneNumber &&
            validationSave.donorBirthdate &&
            validationSave.organType &&
            validationSave.recipientAlias &&
            validationSave.recipientFirstName &&
            validationSave.recipientLastName &&
            validationSave.recipientAboType &&
            validationSave.recipientGender &&
            validationSave.recipientBirthdate &&
            validationSave.recipientPrimaryInsurance &&
            validationSave.recipientUnosCpra &&
            validationSave.recipientAliasDuplicate &&
            validationSave.surgeryBilled &&
            validationSave.surgeryInsurance
        );
    }

    formatPhoneNumber = (phoneNumber: string): string => {
        if (!phoneNumber) return '';
        const digits = phoneNumber.replace(/\D/g, '');
        if (digits.length === 10) {
            return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
        }
        return phoneNumber;
    }

    stripPhoneNumber = (phoneNumber: string): string => {
        if (!phoneNumber) return '';
        return phoneNumber.replace(/\D/g, '');
    }

    handleDetailsChange = (field: string, value: any) => {
        let data = _.cloneDeep(this.state.data)

        if (field == 'donorState') {
            data[field] = parseInt(value);
        } else {
            data[field] = value;
        }

        if (field == 'donorEmail') {
            this.setState({
                data,
                showExistingRegistrationNotice: false
            });
        } else {
            this.setState({
                data
            });
        }
    }

    applyExistingRegistration = (viewData: IDashDonorShield, donorEmail: string) => {
        return {
            id: 0,
            watrId: 0,
            isBilled: false,
            centerId: this.props.centerId,
            surgeryDate: viewData.surgeryDate,
            donorId: 0,
            donorUnosId: '',
            donorAlias: '',
            donorEmail,
            donorAboType: viewData.donorAbo,
            donorGender: viewData.donorGender,
            donorName: viewData.donorName,
            donorAddressLine1: viewData.donorAddress1,
            donorAddressLine2: '',
            donorCity: viewData.donorCity,
            donorState: viewData.donorState,
            donorPostalCode: viewData.donorPostal,
            donorPhoneNumber: this.formatPhoneNumber(viewData.donorPhone),
            donorBirthdate: viewData.donorBirthDate,
            organType: viewData.organType,
            recipientAlias: '',
            recipientEmail: '',
            recipientFirstName: '',
            recipientLastName: '',
            recipientAboType: 0,
            recipientUnosCpra: '',
            recipientGender: 0,
            recipientBirthdate: '',
            recipientPrimaryInsurance: 0,
            recipientSecondaryInsurance: 0,
            country: Country.UnitedStates,
            countryOfCitizenship: Country.UnitedStates,
            hasStreamlinedSerologyOrder: false
        } as IDonorShieldDirectAddEdit;
    }

    handleDonorEmailBlur = () => {
        if (this.state.category !== DonorShieldDirectCategory.AddDonor || this.state.id > 0) {
            return;
        }

        let email = (this.state.data.donorEmail || '').trim();

        if (!Utility.isValidEmail(email)) {
            return;
        }

        if (email.toLowerCase() === this.state.lastLookedUpEmail.toLowerCase()) {
            return;
        }

        this.props.showLoading('Checking existing registrations, one moment please...').then(async () => {
            try {
                let response = await this.props.getExistingRegistrations(this.props.centerId, email);

                if (response.data.success) {
                    let results = response.data.results || [];
                    let match = results.length > 0 ? results[0] : null;

                    if (match != null) {
                        this.setState({
                            data: this.applyExistingRegistration(match, email),
                            lastLookedUpEmail: email,
                            showExistingRegistrationNotice: true
                        });
                    } else {
                        this.setState({
                            lastLookedUpEmail: email,
                            showExistingRegistrationNotice: false
                        });
                    }
                } else {
                    toast.error('Unable to get existing records: ' + response.data.message);
                    this.setState({
                        lastLookedUpEmail: email,
                        showExistingRegistrationNotice: false
                    });
                }
            } finally {
                this.props.hideLoading();
            }
        });
    }

    handleDismissExistingRegistrationNotice = () => {
        this.setState({
            showExistingRegistrationNotice: false
        });
    }

    validateAddress = async () => {
        let { donorAddressLine1, donorAddressLine2, donorCity, donorState, donorPostalCode } = this.state.data;

        let addressValidation: IUsPsAddressResponse = null;

        let stateItem = this.state.stateList.find(x => x.id == donorState)?.abbreviation;

        if (donorAddressLine1 && donorCity && donorState && donorPostalCode) {
            let addressValidationResponse = await this.props.validateAddress(donorAddressLine1, donorAddressLine2, donorCity, stateItem, donorPostalCode);

            if (addressValidationResponse.data?.results != null) {
                addressValidation = addressValidationResponse.data.results;
            }
        }

        return addressValidation;
    };

    handleCheckAddress = async (sendInvite: boolean) => {
        let { donorAddressLine1, donorAddressLine2, donorCity, donorState, donorPostalCode } = this.state.data;

        this.props.showLoading('Validating address, one moment please...')
            .then(async () => {
                let addressValidation = await this.validateAddress();

                let stateItem = this.state.stateList.find(x => x.id == donorState);

                let newAddressValidation = {
                    show: addressValidation.result != AddressValidationResult.Valid,
                    response: addressValidation,
                    submittedAddress: {
                        street: donorAddressLine1,
                        street2: donorAddressLine2,
                        city: donorCity,
                        state: stateItem.abbreviation,
                        postalCode: donorPostalCode
                    },
                }

                this.setState({
                    addressValidation: newAddressValidation,
                    sendInvite
                }, () => {
                    if (addressValidation.result == AddressValidationResult.Valid) {
                        this.handleSave(sendInvite);
                    }
                });
            })
            .finally(() => {
                this.props.hideLoading()
            });
    }

    handleValidate = async (sendInvite: boolean) => {
        let {
            donorAddressLine1,
            donorAddressLine2,
            donorCity,
            donorState,
            donorPostalCode,
        } = this.state.data;

        let {
            originalData: {
                address: originalAddress,
                address2: originalAddress2,
                city: originalCity,
                state: originalState,
                postalCode: originalPostalCode
            }
        } = this.state;

        if (donorAddressLine1 != originalAddress || donorAddressLine2 != originalAddress2 || donorCity != originalCity || donorState != originalState || donorPostalCode != originalPostalCode) {
            this.handleCheckAddress(sendInvite);
        } else {
            this.handleSave(sendInvite);
        }
    };

    handleUseAddress = (recommended: boolean) => {
        let { data, sendInvite } = this.state;
        let { response } = this.state.addressValidation;

        if (recommended) {
            let stateId = this.state.stateList.find(x => x.abbreviation == response.state)?.id;

            data.donorAddressLine1 = response.address1;
            data.donorAddressLine2 = response.address2;
            data.donorCity = response.city;
            data.donorState = stateId;
            data.donorPostalCode = response.zip5;
        }

        this.setState({
            data,
            addressValidation: {
                show: false,
                response: null,
                submittedAddress: null,
            }
        }, () => {
            this.handleSave(sendInvite);
        });
    }

    handleCancelAddressValidation = () => {
        this.setState({
            addressValidation: {
                show: false,
                response: null,
                submittedAddress: null,
            }
        });
    }

    handleSave = async (sendInvite: boolean) => {
        let validationSave = await this.validateSave();

        this.setState({
            validationSave,
            dirty: true
        }, async () => {
            if (this.isValid()) {

                let {
                    id, centerId, surgeryDate, organType,
                    donorUnosId, donorAlias, donorEmail, donorAboType, donorGender, donorName, donorAddressLine1, donorAddressLine2, donorCity, donorState, donorPostalCode, donorPhoneNumber, donorBirthdate,
                    recipientAlias, recipientEmail, recipientFirstName, recipientLastName, recipientUnosCpra, recipientAboType, recipientGender, recipientBirthdate, recipientPrimaryInsurance, recipientSecondaryInsurance
                } = this.state.data;

                let request = {
                    id, centerId, surgeryDate, organType,
                    donorUnosId, donorAlias, donorEmail, donorAboType, donorGender, donorName, donorAddressLine1, donorAddressLine2, donorCity, donorState, donorPostalCode, donorPhoneNumber: this.stripPhoneNumber(donorPhoneNumber), donorBirthdate,
                    recipientAlias, recipientEmail, recipientFirstName, recipientLastName, recipientUnosCpra, recipientAboType, recipientGender, recipientBirthdate, recipientPrimaryInsurance, recipientSecondaryInsurance
                };

                let aliasExists = false;

                if (request.donorEmail !== this.state.originalDonorEmail || request.donorAlias !== this.state.originalDonorAlias) {
                    aliasExists = await this.handleCheckDonorShieldDirectAliasExists(request.donorEmail, DonorShieldAliasType.DonorShieldDirect, request.donorAlias, request.id, organType);
                }

                if (!aliasExists) {
                    this.props.showLoading('Saving Donor Shield Donation, one moment please...').then(async () => {
                        if (this.state.id > 0) {
                            this.props.updateDonorShieldDirectRecord(this.state.id, request)
                                .then(response => {
                                    if (response.data.success) {
                                        if (sendInvite) {
                                            window.location.href = '/center/' + this.props.centerId + '/donors/watr/add-request?donorShieldId=' + this.state.id;
                                        } else {
                                            toast.success('Donor Shield Donation updated successfully');
                                            this.setState({
                                                originalDonorAlias: request.donorAlias,
                                                originalDonorEmail: request.donorEmail
                                            })
                                        }
                                    } else {
                                        if (response.data.aliasCheck != null) {
                                            if (!response.data.aliasCheck.success) {
                                                let aliasCheck = response.data.aliasCheck;
                                                this.setState({
                                                    aliasCheck: { type: aliasCheck.type, alias: aliasCheck.alias, email: aliasCheck.email }
                                                }, () => {
                                                    this.handleShowAliasCheckModal(true)
                                                })
                                            }
                                        } else {
                                            toast.error('Unable to save Donor Shield Donation: ' + response.data.message);
                                        }
                                    }
                                })
                                .finally(() => {
                                    this.props.hideLoading();
                                });
                        } else {
                            this.props.addDonorShieldDirectRecord(request)
                                .then(response => {
                                    if (response.data.success) {
                                        let newId = response.data.results.id;

                                        this.setState({
                                            orderSerologyConfirmation: {
                                                show: true,
                                                inviteToDS: sendInvite,
                                                newId
                                            }
                                        });
                                    } else {
                                        if (response.data.aliasCheck != null) {
                                            if (!response.data.aliasCheck.success) {
                                                let aliasCheck = response.data.aliasCheck;
                                                this.setState({
                                                    aliasCheck: { type: aliasCheck.type, alias: aliasCheck.alias, email: aliasCheck.email }
                                                }, () => {
                                                    this.handleShowAliasCheckModal(true)
                                                })
                                            }
                                        } else {
                                            toast.error('Unable to save Donor Shield Donation: ' + response.data.message);
                                        }
                                    }
                                })
                                .finally(() => {
                                    this.props.hideLoading();
                                });
                        }
                    });
                }
            }
        });
    }

    handleOrderSerologyConfirm = () => {
        let { newId, inviteToDS } = this.state.orderSerologyConfirmation;

        let url = '/center/' + this.props.centerId + '/action-center/home-blood-draw/streamlined-serology?donorShieldId=' + newId;

        if (inviteToDS) {
            url += '&inviteToDS=1'
        }

        window.location.href = url
    }

    handleOrderSerologyCancel = () => {
        let { newId, inviteToDS } = this.state.orderSerologyConfirmation;

        if (inviteToDS) {
            window.location.href = '/center/' + this.props.centerId + '/donors/watr/add-request?donorShieldId=' + newId;
        } else {
            window.location.href = '/center/' + this.props.centerId + '/donors/donor-shield-direct/edit-donor/' + newId;
        }
    }

    handleOrderSerologyExit = () => {
        this.setState({
            orderSerologyConfirmation: {
                newId: 0,
                inviteToDS: false,
                show: false,
            }
        })
    }

    handleCheckDonorShieldDirectAliasExists = async (email: string, type: DonorShieldAliasType, alias: string = '', id: number = 0, organType: OrganType = OrganType.Kidney) => {
        let aliasResponse = await this.props.checkDonorShieldDirectAlias(email, alias, type, id, organType);
        let data = aliasResponse.data;

        if (!data.success) {
            if (data.email == '' && data.alias == '' && data.message != '') {
                toast.error(data.message);
            } else {
                this.setState({
                    aliasCheck: aliasResponse.data
                }, () => {
                    this.handleShowAliasCheckModal(true)
                })
            }

            return true;
        } else {
            return false;
        }
    }

    handleShowAliasCheckModal = (show: boolean) => {
        if (show) {
            this.setState({
                showAliasCheckModal: true
            })
        } else {
            this.setState({
                showAliasCheckModal: false,
                aliasCheck: {
                    type: DonorShieldAliasType.DonorShieldDirect,
                    email: '',
                    alias: ''
                }
            })
        }
    }

    handleCancel = () => {
        window.location.href = '/center/' + this.props.centerId + '/donors/donor-shield-direct/pending-transplant'
    }

    handleTabChange = (category: number) => {
        let tab = tabMap.find(x => x.id == category);
        let prefix = this.props.isAdmin ? '/admin/donors/donor-shield-direct/' : '/center/' + this.props.centerId + '/donors/donor-shield-direct/';
        let newUrl = prefix + tab.section.toLowerCase();

        if (tab.section.toLowerCase() == "upload-lost-wage") {
            newUrl = 'center/' + this.props.centerId + '/donors/watr/add-request';
        }

        window.location.href = newUrl;
    }

    render = () => {
        const isValid = this.isValid();
        const isAddingDonor = this.state.category == DonorShieldDirectCategory.AddDonor;

        return (
            <div>
                <AddEditWrapper className='container-fluid'>
                    <Row>
                        <Col xs={12} lg={8}>
                            <h2 style={{ marginTop: 0 }}>{this.props.donorShieldId > 0 ? 'Edit' : 'Add'} Donor Shield Donation</h2>
                        </Col>
                    </Row>

                    {!isValid && (
                        <Alert bsStyle='danger'>Please specify the items in red below...</Alert>
                    )}

                    {this.state.showExistingRegistrationNotice && (
                        <Alert bsStyle='info' onDismiss={this.handleDismissExistingRegistrationNotice}>
                            An existing registration was found for this email. Donor details have been filled in from that record.
                        </Alert>
                    )}

                    <Row>
                        <Col xs={12} lg={8}>
                            <SurgeryDetails
                                surgeryDate={this.state.data.surgeryDate}
                                organType={this.state.data.organType}
                                validation={this.state.validationSave}
                                dirty={this.state.dirty}
                                isAddingDonor={isAddingDonor}
                                organTypeList={this.state.organTypeList}
                                isExpertSystemCenter={this.state.isExpertSystemCenter}
                                onDataChange={this.handleDetailsChange} />

                            <DonorDetails
                                donorUnosId={this.state.data.donorUnosId}
                                donorAlias={this.state.data.donorAlias}
                                donorEmail={this.state.data.donorEmail}
                                donorAboType={this.state.data.donorAboType}
                                donorGender={this.state.data.donorGender}
                                donorName={this.state.data.donorName}
                                donorAddressLine1={this.state.data.donorAddressLine1}
                                donorAddressLine2={this.state.data.donorAddressLine2}
                                donorCity={this.state.data.donorCity}
                                donorState={this.state.data.donorState}
                                donorPostalCode={this.state.data.donorPostalCode}
                                donorPhoneNumber={this.state.data.donorPhoneNumber}
                                donorBirthdate={this.state.data.donorBirthdate}
                                validation={this.state.validationSave}
                                dirty={this.state.dirty}
                                stateList={this.state.stateList}
                                onDataChange={this.handleDetailsChange}
                                onDonorEmailBlur={isAddingDonor ? this.handleDonorEmailBlur : undefined} />

                            <RecipientDetails
                                recipientAlias={this.state.data.recipientAlias}
                                recipientEmail={this.state.data.recipientEmail}
                                recipientFirstName={this.state.data.recipientFirstName}
                                recipientLastName={this.state.data.recipientLastName}
                                recipientUnosCpra={this.state.data.recipientUnosCpra}
                                recipientAboType={this.state.data.recipientAboType}
                                recipientGender={this.state.data.recipientGender}
                                recipientBirthdate={this.state.data.recipientBirthdate}
                                recipientPrimaryInsurance={this.state.data.recipientPrimaryInsurance}
                                recipientSecondaryInsurance={this.state.data.recipientSecondaryInsurance}
                                validation={this.state.validationSave}
                                dirty={this.state.dirty}
                                insuranceList={this.state.insuranceList}
                                onDataChange={this.handleDetailsChange} />

                            <Row>
                                <Col xs={12} lg={2} lgOffset={3}>
                                    <Button bsStyle='primary' block onClick={() => this.handleValidate(false)}>Save</Button>
                                </Col>
                                {!this.state.data.watrId && (
                                    <Col xs={12} lg={3}>
                                        <Button bsStyle='success' block onClick={() => this.handleValidate(true)}>Save & Request Reimbursement</Button>
                                    </Col>
                                )
                                }
                                <Col xs={12} lg={2}>
                                    <Button block onClick={this.handleCancel}>Cancel</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </AddEditWrapper>

                <AddressValidation
                    show={this.state.addressValidation.show}
                    response={this.state.addressValidation.response}
                    submittedAddresss={this.state.addressValidation.submittedAddress}
                    onUseAddress={this.handleUseAddress}
                    onCancel={this.handleCancelAddressValidation}
                />

                <DonorShieldAliasCheckModal
                    show={this.state.showAliasCheckModal}
                    data={this.state.aliasCheck}
                    onCancel={this.handleShowAliasCheckModal}
                />

                <OrderSerologyConfirmation
                    show={this.state.orderSerologyConfirmation.show}
                    onConfirm={this.handleOrderSerologyConfirm}
                    onCancel={this.handleOrderSerologyCancel}
                    onExit={this.handleOrderSerologyExit}
                />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app,
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDonorShieldLookupData: (centerId, isAdmin) => {
            return dispatch(DonorShieldDirectActionCreators.getDonorShieldLookupData(centerId, isAdmin));
        },
        getDonorShieldDirectRecord: (requestId) => {
            return dispatch(DonorShieldDirectActionCreators.getDonorShieldDirectRecord(requestId));
        },
        addDonorShieldDirectRecord: (request) => {
            return dispatch(DonorShieldDirectActionCreators.addDonorShieldDirectRecord(request));
        },
        updateDonorShieldDirectRecord: (id, request) => {
            return dispatch(DonorShieldDirectActionCreators.updateDonorShieldDirectRecord(id, request));
        },
        getExistingRegistrations: (centerId, donorEmail) => {
            return dispatch(DonorShieldDirectActionCreators.getExistingRegistrations(centerId, donorEmail));
        },
        getDuplicateCounts: (donorShieldId, donorAlias, recipientAlias) => {
            return dispatch(DonorShieldDirectActionCreators.getDuplicateCounts(donorShieldId, donorAlias, recipientAlias));
        },
        checkDonorShieldDirectAlias: (email, alias, type, id, organType) => {
            return dispatch(DonorShieldDirectActionCreators.checkDonorShieldDirectAlias(email, alias, type, id, organType))
        },
        validateAddress: (address, address2, city, state, postalCode) => {
            return dispatch(DonorShieldDirectActionCreators.validateAddress(address, address2, city, state, postalCode));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorShieldDirectAddEdit);